import { render, staticRenderFns } from "./ControllerPage.vue?vue&type=template&id=efaffac0&scoped=true&"
import script from "./ControllerPage.vue?vue&type=script&lang=js&"
export * from "./ControllerPage.vue?vue&type=script&lang=js&"
import style0 from "./ControllerPage.vue?vue&type=style&index=0&id=efaffac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaffac0",
  null
  
)

export default component.exports